import "babel-polyfill"
import React from "react"
import { render } from "react-dom"
import { createStore, applyMiddleware } from "redux"
import { Provider } from "react-redux"
import io from "socket.io-client"

import "bootstrap/dist/css/bootstrap.min.css"
import "./index.css"

import App from "./App"
import reducer from "./reducers"
import remoteActionMiddleware from "./remote_action_middleware"
import registerServiceWorker from "./registerServiceWorker"

import { socket_protocol, socket_host, socket_port } from "./components/Common.js"

// const socket_host = process.env.REACT_APP_SOCKET_HOSTNAME || window.location.hostname
// const socket_port = process.env.REACT_APP_SOCKET_PORT || 53300

const socket = io(`${socket_protocol}//${socket_host}:${socket_port}`)
// const socket = io(`${window.location.protocol}//${socket_host}:${socket_port}`)
// const createStoreWithMiddleware = applyMiddleware(
//   remoteActionMiddleware(socket)
// )(createStore)
const store = applyMiddleware(
  remoteActionMiddleware(socket)
)(createStore)(reducer)

socket.on("state", new_state => store.dispatch({ type: "SET_STATE", new_state }))

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js